<template>
    <ion-page>
        <nav-bar-book title="Aperçu de mon livre" background-color="white"
                      :show-back-button="false" :show-orders-button="true" :book="book"
                      :nb-pages="totalPages" :show-summary-button="hasOutline"
                      @summary="$refs.preview?.openOutline($event)"></nav-bar-book>
        <ion-content :fullscreen="true">
            <book-preview-component v-if="this.book?.parameters.length > 0" ref="preview"
                                    :book-id="book.id" @ready="onPreviewReady"></book-preview-component>

            <div v-else-if="!loading"
                 class="h-full w-full bg-primary-light relative flex flex-col items-center justify-center">

                <div class="bg-primary text-white font-bold px-6 py-4 rounded-3xl shadow-lg max-w-screen-sm ">
                    Pour prévisualiser et commander ton livre papier, tu dois d'abord sélectionner les souvenirs que tu
                    souhaites voir à l'intérieur.
                    <br><br>
                    Pour cela, tu dois le personnaliser.
                </div>

                <button-custom @click="$router.push({name: 'book_custom'})" color="primary" shape="round" class="mt-6">
                    Personnaliser mon livre
                </button-custom>

            </div>
            <div v-if="loading"
                 class="bg-white/40 absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center">
                <ion-spinner class="size-12"></ion-spinner>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import { IonContent, IonPage, IonSpinner } from '@ionic/vue';
import { defineComponent } from 'vue';
import NavBarBook from "@/components/NavbarBook.vue";
import ButtonCustom from "@/components/ButtonCustom.vue";
import BookPreviewComponent from "@/components/book/BookPreviewComponent.vue";

export default defineComponent({
    name: 'BookHomePage',
    components: {
        NavBarBook,
        BookPreviewComponent,
        IonContent,
        IonPage,
        IonSpinner,
        ButtonCustom
    },
    data() {
        return {
            book: null,
            totalPages: 1,
            hasOutline: false,
            loading: true,
        }
    },
    ionViewWillEnter() {
        this.loadBook();
    },
    methods: {
        loadBook: function () {
            this.loading = true;
            this.axios.get('house/' + this.$route.params.house + '/book')
                .then((response) => {
                    this.book = response.data.data;
                    this.loading = false;

                    if (this.book.parameters.length <= 0) {
                        return;
                    }

                    this.getBookNbPages();

                    // Le livre a pu être repersonnalisé depuis la dernière visite :
                    // l'aperçu déjà monté ne le refléterait pas.
                    this.$nextTick(() => this.$refs.preview?.reload());
                });
        },

        // Le sommaire n'existe qu'une fois l'aperçu chargé : c'est lui qui le tient du gabarit.
        onPreviewReady: function ({ outline }) {
            this.hasOutline = outline.length > 0;
        },

        getBookNbPages: function () {
            this.axios.get('house/' + this.$route.params.house + '/book/' + this.book.id + '/count-pages')
                .then((response) => {
                    this.totalPages = response.data;
                });
        },
    },
});
</script>

<style scoped>

</style>
